import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useGetPoolOptions } from '../../../../Tables/Settings/PlanUnits/components/utils/useGetPoolOptions';
import { toOptions } from 'utils/toOptions';

import {
  useGetClusters,
  useGetCostCentersWithoutFilter
} from '../../../../../../queries';
import {
  ControlledCheckboxAutoComplete,
  ControlledSelect
} from '../../../../../shared';
import { Box } from '@mui/material';
import { onRemoveElement } from '../utils/onRemoveElement';

const BasePlanSection = () => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.procedures.reports'
  });
  const { control, setValue, watch } = useFormContext();
  const { data: pools } = useGetPoolOptions();
  const { data: clusters } = useGetClusters();
  const { data: customerCostCenter } = useGetCostCentersWithoutFilter();

  return (
    <>
      <Box>
        <ControlledCheckboxAutoComplete
          fullWidth
          name={'br_id_list'}
          label={t('customerCostCenter')}
          variant="outlined"
          options={customerCostCenter ?? []}
          control={control}
          idProperty="brId"
          labelProperty="name"
          allowItemRemoval
          onRemoveElement={(id) =>
            onRemoveElement(setValue, watch, 'br_id_list', id)
          }
        />
      </Box>
      <ControlledSelect
        variant="outlined"
        control={control}
        name="cluster_list"
        label={t('cluster')}
        options={toOptions(clusters ?? [], 'clusterId', 'name')}
      />
      <ControlledSelect
        variant="outlined"
        control={control}
        name="pool_list"
        label={t('pool')}
        options={pools}
      />
    </>
  );
};

export default BasePlanSection;
